import {
  makeObservable,
  makeAutoObservable,
  observable,
  computed,
  action,
  runInAction
} from 'mobx';

import utils from '../assets/scripts/utils';

export default class AppVM {
  // 靜音
  @observable isMuted = false;

  constructor() {
    makeObservable(this);
  }

  @action
  getMuted = () => {
    const dataString = utils.localStorage().get();
    const data = dataString ? JSON.parse(dataString) : { isMuted: false };

    this.isMuted = data.isMuted;
    utils.localStorage().set(this.isMuted);
  };

  @action
  setMuted = () => {
    this.isMuted = !this.isMuted;
    utils.localStorage().set(this.isMuted);
  };
}
